import { ChangeDetectionStrategy, Component, HostBinding, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-metadata-view',
  templateUrl: './metadata-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetadataViewComponent {
  @HostBinding('class')
  private classes = 'inline-flex flex-col whitespace-nowrap font-main text-base';

  @Input()
  darkText = false;

  @Input()
  metadataValue: string | number;

  @Input()
  overflowTooltipPlacement?: string;

  @Input()
  metadataDescriptionTranslationKey: string;

  @Input()
  icon: string;

  @Input()
  iconTooltip: string | TemplateRef<any>;

  @Input()
  boldValue = false;

  @Input()
  infoIconTooltip: string;
}
